import React, { useEffect } from 'react'
import Select from 'react-select'
import { IProviderProductObject } from '../../../types/index'
import CrossIcon from '../../icons/ui/CrossIcon'

interface IServiceProductsProps {
  formRef: any
  serviceId: string
  organizationId: string
  serviceProducts: IProviderProductObject[]
  providerProducts: IProviderProductObject[]
  onSelectProduct: (product: IProviderProductObject, serviceId: string) => void
  onRemoveProduct: (productId: string, serviceId: string) => void
  fetchProductsByOrganizationId: (organizationId: string) => void
  onStepSuccessfullyCompleted: () => void
  updateProducts: (serviceId: string, productIds: string[]) => Promise<any>
}

const ServiceProducts = (props: IServiceProductsProps) => {
  const {
    serviceId,
    serviceProducts = [],
    providerProducts,
    onSelectProduct,
    onRemoveProduct,
    organizationId,
    fetchProductsByOrganizationId,
    formRef,
    onStepSuccessfullyCompleted,
    updateProducts
  } = props

  useEffect(() => {
    fetchProductsByOrganizationId(organizationId)
  }, [])

  const handleSubmit = () => {
    updateProducts(serviceId, serviceProducts.map(p => p.id)).then(() => {
      if (onStepSuccessfullyCompleted) {
        onStepSuccessfullyCompleted()
      }
    })
  }

  const handleProductSelect = (option: any) => {
    if (!option) {
      return
    }

    const selectedProduct = !providerProducts ? null : providerProducts.find(it => it.id === option.value)

    if (selectedProduct) {
      onSelectProduct(selectedProduct, serviceId)
    }
  }

  const handleProductDelete = (product: IProviderProductObject) => () => {
    onRemoveProduct(product.id, serviceId)
  }

  const productOptions = !providerProducts
    ? []
    : providerProducts
        .filter(it => !serviceProducts.find(el => el.id === it.id))
        .map(it => ({ value: it.id, label: it.name }))

  return (
    <div className='flex flex-column pt2 pl3 pr3'>
      <div ref={formRef} onClick={handleSubmit} />
      <div className='flex flex-wrap'>
        {serviceProducts &&
          serviceProducts.map(it => (
            <div key={`service-product-${it.id}`} className='ServiceProviderProduct block'>
              <div className='border-light-grey4 rounded mt1 pl1 pr1 pt0 pb01 inline-block'>
                <div className='flex flex-row items-center'>
                  <div className='h6 font-blue-grey'>{it.name}</div>
                  <CrossIcon className='icon--6x6 ml1 cursor--pointer' onClick={handleProductDelete(it)} />
                </div>
              </div>
            </div>
          ))}
      </div>

      {productOptions.length > 0 && (
        <div className='ServiceProviderProductSelect mt1'>
          <Select name={`product`} value={null} options={productOptions} onChange={handleProductSelect} />
        </div>
      )}
    </div>
  )
}

export default ServiceProducts



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceProducts.tsx